"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.signInSchema = void 0;
const zod_1 = require("zod");
/**
 * Sign-in request body. Email is trimmed and lowercased so the rest of the
 * pipeline compares against a canonical value. Password complexity is enforced
 * at password-set time, not at sign-in.
 */
exports.signInSchema = zod_1.z.object({
    email: zod_1.z.string().trim().toLowerCase().email('Enter a valid email.'),
    password: zod_1.z.string().min(1, 'Enter your password.'),
});
//# sourceMappingURL=sign-in.schema.js.map